import { createApp } from 'vue';
import DocToPdfAConverter from '@/Components/DocToPdfAConverter.vue';
import '@styles/app.css';

createApp(DocToPdfAConverter).mount('#doc-to-pdfa-converter');
